import React from "react";
import { Control, Controller, DeepMap, FieldError, FieldValues, SubmitErrorHandler, SubmitHandler } from "react-hook-form";
import { FormProps } from "./UploadFeeDocument";
import { DropdownList } from "react-widgets";
import ErrorMessage from "../../../../../components/text/ErrorMessage";
import { DraftProposalStatus, ProposalReason } from "../../../../../core";

interface UploadFeeLetterRejectConfirmProps {
    control: Control<FormProps>;
    errors: DeepMap<FormProps, FieldError>;
    handleSubmit: <TSubmitFieldValues extends FieldValues = FormProps>(onValid: SubmitHandler<TSubmitFieldValues>, onInvalid?: SubmitErrorHandler<FormProps> | undefined) => (e?: React.BaseSyntheticEvent) => Promise<void>
    isSaving: boolean;
    onReject: (data: any) => Promise<void>;
    title: string | undefined;
    reasons: ProposalReason[];
    setStatusModalOpen: React.Dispatch<React.SetStateAction<{
        isOpen?: boolean;
        status?: DraftProposalStatus;
        documentCopyType?: string;
    }>>
}

export function UploadFeeLetterRejectConfirm({ control,
    errors,
    handleSubmit,
    isSaving,
    onReject,
    reasons,
    title,
    setStatusModalOpen }: UploadFeeLetterRejectConfirmProps) {
    return (
        <>
            <div
                className="modal fade show in"
                id="exampleModal"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-confirm modal-dialog-centered">
                    <div className="modal-content rounded-0">
                        <div className="modal-body text-center">
                            <form onSubmit={handleSubmit(onReject)}>
                                <div className="container">
                                    <div className="row">
                                        <div className="col">
                                            <p>Are you sure to Reject the {title}</p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <div className="form-group font-weight-semibold mb-3 text-left">
                                                <label htmlFor="" className="font-sm text-uppercase">
                                                    Reason<span className="text-danger">*</span>
                                                </label>
                                                <Controller
                                                    control={control}
                                                    name="reason"
                                                    rules={{ required: true }}
                                                    render={({ onChange, value, name }) => (
                                                        <DropdownList
                                                            value={value}
                                                            data={reasons}
                                                            defaultValue={value}
                                                            textField={"reason"}
                                                            valueField={"reason"}
                                                            placeholder={"Select Reason"}
                                                            onChange={(val) => {
                                                                onChange(val.reason);
                                                            }}
                                                        />
                                                    )}
                                                />
                                                {errors.reason && (
                                                    <ErrorMessage>Reason is required</ErrorMessage>
                                                )}
                                            </div>

                                            <div className="form-group font-weight-semibold mb-3 text-left">
                                                <label htmlFor="" className="font-sm text-uppercase">
                                                    Comments
                                                </label>
                                                <Controller
                                                    control={control}
                                                    name="comment"
                                                    render={({ onChange, value, name }) => (
                                                        <input
                                                            type="text"
                                                            className="form-control rounded-sm font-weight-semibold"
                                                            placeholder="Enter comment"
                                                            name={name}
                                                            value={value}
                                                            onChange={onChange}
                                                            id="comment"
                                                        />
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-auto mr-auto">
                                            <button
                                                className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-md-5 px-4 mr-3"
                                                onClick={() => {
                                                    setStatusModalOpen({});
                                                }}
                                                disabled={isSaving}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                        <div className="col-auto">
                                            <button
                                                className="btn btn-primary py-2 font-weight-semibold font-normal px-4 flex-fill"
                                                disabled={isSaving}
                                            >
                                                Yes
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </>
    );
}
